// After "Log in with Twitch", fill in the site's "Who are you?" username (prefs.myUsername)
// with the Twitch login. Runs once per login, before the app mounts (main.js), so every
// page reads the new name on its first render. Logging in is a shortcut: anyone can still
// type a name in Settings instead.
import { twitchAuth, whoami } from './twitchAuth.js';
import { loadPrefs, savePrefs } from './userPrefs.js';

export async function syncTwitchName() {
  const a = twitchAuth();
  if (!a || a.login) return;   // not logged in, or already handled
  const login = await whoami();
  if (login) savePrefs({ ...loadPrefs(), myUsername: login });
}
